import {createHashRouter, Navigate} from "react-router-dom";

import DefaultLayout from "./components/DefaultLayout";
import About from "./pages/about";
import Contact from "./pages/contact";
import Education from "./pages/Education";
import Experience from "./pages/experience";
import Profile from "./pages/profile";
import Skills from "./pages/skills";
import NotFoundComponent from "./src/pages/NotFoundComponent";

const router = createHashRouter([
    {
        path: '/',
        element: <DefaultLayout/>,

        children: [
            {
                path: '/',
                element: <Navigate to='/about-me'/>
            },
            {
                path: '/about-me',
                element: <About/>
            },
            {
                path: '/contact-me',
                element: <Contact />
            },
            {
                path: '/education',
                element: <Education />
            },
            {
                path: '/working-experience',
                element: <Experience />
            },
            {
                path: '/profile',
                element: <Profile />
            },
            {
                path: '/skills',
                element: <Skills />
            },
            {
                path: '*',
                element: <NotFoundComponent />
            }
        ]
    }
]);

export default router;